/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ColumnMetaDataContext;
(function (ColumnMetaDataContext) {
    ColumnMetaDataContext["NONE"] = "none";
    ColumnMetaDataContext["IDENTIFIER"] = "identifier";
    ColumnMetaDataContext["VALUES"] = "values";
    ColumnMetaDataContext["DATETIME"] = "datetime";
    ColumnMetaDataContext["TIMEPOINT"] = "timepoint";
    ColumnMetaDataContext["DESCRIPTION"] = "description";
    ColumnMetaDataContext["CUSTOM"] = "custom";
    ColumnMetaDataContext["TAG_DESCRIPTION"] = "tag_description";
})(ColumnMetaDataContext || (ColumnMetaDataContext = {}));
export function ColumnMetaDataContextFromJSON(json) {
    return ColumnMetaDataContextFromJSONTyped(json, false);
}
export function ColumnMetaDataContextFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ColumnMetaDataContextToJSON(value) {
    return value;
}
